import React from "react";
import { Typography, Grid, Divider, IconButton, Button } from "@material-ui/core";
import { useSelector } from "react-redux";
import { makeStyles, createStyles, withStyles } from "@material-ui/core/styles";
import { Skeleton } from "@material-ui/lab";

import { useTranslation } from "react-i18next";


export const StyleIconButton = withStyles({
  root: {
    padding: "10%",
  },
})(IconButton);

const useStyles = makeStyles((theme) =>
  createStyles({
    headerHr: {
      backgroundColor: theme.palette.eLight.base,
    },
    gridContent: {
      margin: "1% 0",
    },
    titleStyle: {
      color: theme.palette.ePrimary.base,
      [theme.breakpoints.down("xs")]: {
        paddingLeft: "0%",
      },
      // paddingLeft: "17.33%",
    },
    downloadIcon: {
      width: "2rem",
      cursor: "pointer",
    },
   
  })
);

export default function Header({ ticketNo, content }) {
  let classes = useStyles();
  const { t: labels, ready: labelReady } = useTranslation("label-E_CONFIRMATION_SCREEN");
 
  let supportEmail = useSelector(
    (store) =>
      store?.parametersWidgets?.ParameterLookup?.CUSTOMER_HELP_EMAIL_ADDRESS
  );
 
  
  return (
    <Grid container alignItems="center" justify="center">
      <Grid item xs={12} sm={10} className={classes.gridContent}>
        <Typography
          variant="h5"
          component="h6"
          align="center"
          className={classes.titleStyle}
        >
          <b> {labels("E_CONFIRMATION_TITLE")}</b>
        </Typography>
      </Grid>
     
      <Grid item xs={12} className={classes.gridContent}>
        <Divider className={classes.headerHr}></Divider>
      </Grid>
    </Grid>
  );
}
